import english from "./english";

const lang = (key) => (english[key] ? english[key] : (key));

export default lang;
